import React from 'react'
import { CameraStyle, CameraStatus } from './style'

export const CameraDesc = ({ videoPath }) => {

    return (
        <CameraStyle className="fade-in">
            <div className="camera_desc_preview df jcc fdc brs">
                <div className="fs-n">Video Online</div>
                <video width="480" loop className="brs mtn" autoplay controls>
                    <source width="480" src={videoPath} autoplay type="video/mp4" />
                    Your browser doesn't support HTML5 video tag.
                </video>
            </div>
        </CameraStyle>
    )
}